// Global Cart Recommendations Handler
(function() {
  function initializeCartRecommendations() {
    const track = document.querySelector('.cart-recommendations-track');
    if (!track) return;

    const productId = track.dataset.productId;
    const cartProductIds = JSON.parse(track.dataset.cartProducts || '[]');
    
    const prevBtn = document.querySelector('.cart-recommendations-prev');
    const nextBtn = document.querySelector('.cart-recommendations-next');
    
    if (!prevBtn || !nextBtn) return;

    let currentIndex = 0;
    let totalProducts = 0;
    const itemsPerPage = 2;

    // Simple format money - just convert cents to dollars
    function formatMoney(cents) {
      const dollars = (cents / 100).toFixed(2);
      return '$' + dollars;
    }

    function updateNavigation() {
      if (totalProducts <= itemsPerPage) {
        prevBtn.disabled = true;
        nextBtn.disabled = true;
      } else {
        prevBtn.disabled = (currentIndex === 0);
        nextBtn.disabled = (currentIndex >= totalProducts - itemsPerPage);
      }
      
      prevBtn.style.opacity = prevBtn.disabled ? '0.3' : '1';
      nextBtn.style.opacity = nextBtn.disabled ? '0.3' : '1';
      prevBtn.style.cursor = prevBtn.disabled ? 'not-allowed' : 'pointer';
      nextBtn.style.cursor = nextBtn.disabled ? 'not-allowed' : 'pointer';
    }

    function slideToIndex(index) {
      const items = track.querySelectorAll('.cart-recommendation-item');
      if (items.length === 0) return;
      
      const slideWidth = items[0].offsetWidth;
      const gap = 16;
      const offset = -(index * (slideWidth + gap));
      track.style.transform = `translateX(${offset}px)`;
      updateNavigation();
    }

    fetch(`/recommendations/products.json?product_id=${productId}&limit=10`)
      .then(response => response.json())
      .then(data => {
        if (data.products && data.products.length > 0) {
          const recommendations = data.products.filter(p => !cartProductIds.includes(p.id));
          totalProducts = recommendations.length;
          
          if (totalProducts === 0) {
            track.parentElement.parentElement.style.display = 'none';
            return;
          }

          track.innerHTML = recommendations.map(product => {
            const hasDiscount = product.compare_at_price_min > product.price_min;
            
            return `
              <div class="cart-recommendation-item">
                <a href="${product.url}" class="cart-recommendation-image">
                  <img src="${product.featured_image}" alt="${product.title}" loading="lazy">
                </a>
                <div class="cart-recommendation-info">
                  <a href="${product.url}" class="cart-recommendation-title">${product.title}</a>
                  <div class="cart-recommendation-price">
                    ${hasDiscount 
                      ? `<span class="price-sale">${formatMoney(product.price_min)}</span>
                         <span class="price-compare">${formatMoney(product.compare_at_price_min)}</span>`
                      : `<span class="price-regular">${formatMoney(product.price_min)}</span>`
                    }
                  </div>
                  <button class="cart-recommendation-add-btn" onclick="window.location.href='${product.url}'">
                    SELECT OPTIONS
                  </button>
                </div>
              </div>
            `;
          }).join('');

          // Initialize navigation after render
          setTimeout(() => {
            currentIndex = 0;
            updateNavigation();
          }, 100);

          // Prev button click
          prevBtn.addEventListener('click', (e) => {
            e.preventDefault();
            console.log('Prev clicked, current index:', currentIndex);
            if (currentIndex > 0) {
              currentIndex -= itemsPerPage;
              if (currentIndex < 0) currentIndex = 0;
              console.log('New index:', currentIndex);
              slideToIndex(currentIndex);
            }
          });

          // Next button click
          nextBtn.addEventListener('click', (e) => {
            e.preventDefault();
            console.log('Next clicked, current index:', currentIndex);
            const maxIndex = totalProducts - itemsPerPage;
            if (currentIndex < maxIndex) {
              currentIndex += itemsPerPage;
              if (currentIndex > maxIndex) currentIndex = maxIndex;
              console.log('New index:', currentIndex);
              slideToIndex(currentIndex);
            }
          });
        } else {
          track.parentElement.parentElement.style.display = 'none';
        }
      })
      .catch(error => {
        console.error('Error loading recommendations:', error);
        track.parentElement.parentElement.style.display = 'none';
      });
  }

  // Initialize on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeCartRecommendations);
  } else {
    initializeCartRecommendations();
  }

  // Watch for cart drawer updates using MutationObserver
  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.addedNodes.length > 0) {
        for (const node of mutation.addedNodes) {
          // Check if recommendations were added
          if (node.nodeType === 1) { // Element node
            if (node.classList?.contains('cart-recommendations-wrapper') || 
                node.querySelector?.('.cart-recommendations-wrapper')) {
              console.log('Cart recommendations detected, initializing...');
              setTimeout(initializeCartRecommendations, 150);
              return;
            }
          }
        }
      }
    }
  });

  // Start observing
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  // Also listen for custom cart events (common in Shopify themes)
  document.addEventListener('cart:updated', () => {
    setTimeout(initializeCartRecommendations, 200);
  });
  
  document.addEventListener('cart:refresh', () => {
    setTimeout(initializeCartRecommendations, 200);
  });
})();